module.exports = __webpack_public_path__ + "static/media/coin.190968c0.png";